import React, { FC, ReactNode } from 'react'
import { Button, Flex } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { EditableViewWrapper } from '@pushly/aqe/lib/components/hoc/editable-view/editable-view-context'
import './recommendation-configuration-editor.scss'

type RecommendationConfigurationEditorProps = {
    id: string
    readonly: boolean
    configCount: number
    maxConfigs: number
    onAdd: () => void
    children: ReactNode
}

export const RecommendationConfigurationEditor: FC<RecommendationConfigurationEditorProps> = ({
    id,
    readonly,
    configCount,
    maxConfigs,
    onAdd,
    children,
}) => {
    return (
        <div id={id} className="rcn-editor">
            <EditableViewWrapper mode={readonly ? 'view' : 'edit'}>
                <Flex vertical gap="var(--space-4)">
                    {children}

                    {!readonly && configCount < maxConfigs && (
                        <Button
                            type="primary"
                            className="rcn-add-configuration-button"
                            onClick={onAdd}
                            icon={<PlusOutlined aria-hidden="true" />}
                        >
                            Add Configuration
                        </Button>
                    )}
                </Flex>
            </EditableViewWrapper>
        </div>
    )
}
